import {
    FormControl,
    InputBase,
    Typography,
    FormLabel,
} from "@material-ui/core";
import React from "react";
import { lynxInputStyles } from "./LynxInputStyles";
import clsx from "clsx";
import { LynxInputProps } from "./LynxInputProps";

export function LynxInput(props: LynxInputProps) {
    const { size = "medium", error = false } = props;

    const classes = lynxInputStyles({ size, error });

    const inputClassName = clsx(classes.inputBase, props.className);
    const labelClassName = clsx(classes.label, props.labelClassName);
    const assistiveTextClassName = clsx(
        classes.assistiveText,
        props.assistiveTextClassName
    );
    const formControlClassName = clsx(classes.root, props.formControlClassName);

    return (
        <FormControl className={formControlClassName}>
            {props.label && (
                <FormLabel htmlFor={props.name} className={labelClassName}>
                    {props.label}
                </FormLabel>
            )}
            <InputBase
                classes={{
                    focused: classes.focused,
                    input: classes.input,
                    error: classes.error,
                    disabled: classes.disabled,
                }}
                {...props}
                className={inputClassName}
            />
            {props.assistiveText && (
                <Typography
                    variant="subtitle1"
                    className={assistiveTextClassName}
                >
                    {props.assistiveText}
                </Typography>
            )}
        </FormControl>
    );
}
